import config from '../../../config';
import models from '../../../model';
import { getLocale } from '../../../utils';
import { LogicContext } from '../types';

export const fetchBingoGames = (context: LogicContext) => async () => {
  const { status, data } = await models.fetchBingoGames({
    locale: getLocale(config),
    market_country: config.viewer_country,
    market_region: config.viewer_region,
  });

  return {
    status,
    bingoGames: data,
  };
};
